// removed by extract-text-webpack-plugin
module.exports = {"container":"src-components----Box-module---container---3ZtAX","background":"src-components----Box-module---background---2ltvA","spacer":"src-components----Box-module---spacer---1ncxu","content":"src-components----Box-module---content---O_2qx","title":"src-components----Box-module---title---VEBwP","subtitle":"src-components----Box-module---subtitle---3YoHJ"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Box.module.css
// module id = 118
// module chunks = 35783957827783 43201937662106